import { render, staticRenderFns } from "./MulliganWarningModal.vue?vue&type=template&id=7bd5e812"
import script from "./MulliganWarningModal.vue?vue&type=script&lang=js"
export * from "./MulliganWarningModal.vue?vue&type=script&lang=js"
import style0 from "./MulliganWarningModal.vue?vue&type=style&index=0&id=7bd5e812&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports